import secureLocalStorage from 'react-secure-storage';
import { STORAGE_KEYS } from '../constants';

export const SESSION_EXPIRED_EVENT = 'auth:session-expired';

type SessionExpiredDetail = {
  reason: 'expired' | 'logout';
};

export const clearStoredSession = (): void => {
  secureLocalStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  secureLocalStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  secureLocalStorage.removeItem(STORAGE_KEYS.USER);
};

export const expireSession = (): void => {
  clearStoredSession();

  window.dispatchEvent(
    new CustomEvent<SessionExpiredDetail>(SESSION_EXPIRED_EVENT, {
      detail: { reason: 'expired' },
    })
  );
};

export const subscribeToSessionExpiry = (
  listener: (detail: SessionExpiredDetail) => void
): (() => void) => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<SessionExpiredDetail>;
    listener(customEvent.detail ?? { reason: 'expired' });
  };

  window.addEventListener(SESSION_EXPIRED_EVENT, handler as EventListener);

  return () => {
    window.removeEventListener(SESSION_EXPIRED_EVENT, handler as EventListener);
  };
};
